export const ZOOM_IN_SCALE_FACTOR = 1.1;
export const ZOOM_OUT_SCALE_FACTOR = 0.9;
export const INITIAL_ZOOM = 1;

export const CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY = 'data-original-width';
export const CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY = 'data-original-height';

export const ZOOM_TYPE = {
  IN: "IN",
  OUT: "OUT"
};
